/** Case-insensitive email compare (aligned with API normalizeEmail). */
export function emailsEqual(a: string | null | undefined, b: string | null | undefined): boolean {
  const left = (a ?? '').trim().toLowerCase();
  const right = (b ?? '').trim().toLowerCase();
  return !!left && !!right && left === right;
}
